import "./Button.css";

function FilterButtons({ filter, setFilter }) {
  return (
    <>
      <div className="headingButton">
        <button className="ButtonStyle" onClick={() => setFilter("all")}>
          All Task
        </button>
        <button className="ButtonStyle" onClick={() => setFilter("active")}>
          Pending Task
        </button>
        <button className="ButtonStyle" onClick={() => setFilter("completed")}>
          Completed Task
        </button>
      </div>
    </>
  );
}

export default FilterButtons;
